import { STATUS_ORDER, STATUS_META } from "@/lib/pricing";
import { Check } from "lucide-react";

export const StatusTracker = ({ status }) => {
  const currentIdx = STATUS_ORDER.indexOf(status);
  return (
    <div data-testid="status-tracker" className="w-full">
      <div className="flex items-center">
        {STATUS_ORDER.map((s, i) => {
          const done = i <= currentIdx;
          const meta = STATUS_META[s];
          return (
            <div key={s} className="flex flex-1 flex-col items-center last:flex-none">
              <div className="flex w-full items-center">
                <div
                  data-testid={`status-node-${s}`}
                  className="grid h-9 w-9 shrink-0 place-items-center rounded-full border-2 text-white transition-all"
                  style={{
                    backgroundColor: done ? meta.color : "#fff",
                    borderColor: done ? meta.color : "#F0DFE5",
                    color: done ? "#fff" : "#9A7E87",
                  }}
                >
                  {done ? <Check size={16} strokeWidth={3} /> : <span className="text-xs font-bold">{i + 1}</span>}
                </div>
                {i < STATUS_ORDER.length - 1 && (
                  <div className="h-1 flex-1 rounded-full" style={{ backgroundColor: i < currentIdx ? meta.color : "#F0DFE5" }} />
                )}
              </div>
              <span className="mt-2 text-[11px] font-semibold" style={{ color: done ? meta.color : "#9A7E87" }}>
                {meta.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || { label: status, color: "#9A7E87" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold text-white"
      style={{ backgroundColor: meta.color }}
    >
      {meta.label}
    </span>
  );
};
